// One icon per spell, from game-icons.net (CC BY 3.0). The path data is
// generated into src/icons/spellIcons.ts by scripts/fetch-icons.mjs and is
// trusted content, so it is set as markup here.

import { SPELL_ICONS } from '../icons/spellIcons';
import { svg } from '../lib/svg';

const ICON_BOX = 512;

export const createSpellIcon = (spellId: string, className: string): SVGSVGElement => {
  const icon = SPELL_ICONS[spellId];
  const root = svg('svg', {
    class: `spell-icon ${className}`,
    viewBox: `0 0 ${ICON_BOX} ${ICON_BOX}`,
    'aria-hidden': 'true',
  });
  if (icon) root.innerHTML = icon.svg;
  return root;
};

/** Authors to credit, on the About page. */
export const iconAuthors = (): string[] =>
  [...new Set(Object.values(SPELL_ICONS).map((icon) => icon.author))].sort();
